import React from "react";

export default function InspectProgressChip({ inspectedCount, total, className = "" }) {
  if (!total) return null;

  const done = inspectedCount >= total;

  return (
    <div
      className={[
        "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 backdrop-blur",
        done
          ? "bg-emerald-500/15 border-emerald-400/40 text-emerald-100"
          : "bg-slate-950/60 border-white/15 text-slate-200",
        className,
      ].join(" ")}
      title="Progression d'inspection"
    >
      <span className="text-sm">{done ? "✅" : "🔎"}</span>
      <span className="text-[11px] uppercase tracking-[0.18em] opacity-80">
        Inspectés
      </span>
      <span className="font-mono text-xs font-bold">
        {inspectedCount}/{total}
      </span>
    </div>
  );
}

